import moment from "moment";

export function calculateBattery(voltage, is_12v = null, voltage_multiplier = null) {
    // dbg($voltage, true);
    if (voltage_multiplier != null) {
        voltage = voltage * voltage_multiplier;
    }
    else if (is_12v) {
        voltage = voltage / 0.849;
    }

    var levels = [
        2850, 2830, 2815, 2800, 2790, 2780, 2770, 2760, 2750, 2745, 2740, 2738, 2736, 2734, 2732, 2730, 2728, 2726, 2724, 2722, 2721, 2719, 2717, 2716, 2715, 2714, 2712, 2710, 2709, 2708, 2707, 2705, 2704, 2703, 2702, 2701, 2699, 2698, 2697, 2696, 2695, 2694, 2693, 2692, 2691, 2689, 2688, 2687, 2686, 2685, 2683, 2682, 2681, 2680, 2679, 2677, 2676, 2675, 2674, 2673, 2671, 2670, 2669, 2668, 2667, 2665, 2664, 2663, 2662, 2660, 2658, 2657, 2656, 2654, 2652, 2650, 2649, 2647, 2645, 2643, 2641, 2639, 2636, 2631, 2626, 2620, 2613, 2606, 2598, 2590, 2580, 2565, 2550, 2535, 2520, 2505, 2490, 2470, 2450, 2430, 2410
    ];

    var value = 0;
    for (var key in levels) {
        if (voltage >= levels[key]) {
            return (100 - key);
        }
    }
    return 0;
}

export function celciusToFahrenheit(celcius) {
    return Number(celcius) * 9 / 5 + 32;
}

export function convertBattery(voltage, is_32, multiplier) {
    if (typeof multiplier != "undefined" && multiplier != null) {
        voltage = voltage * multiplier;
    }
    else if (typeof is_32 != "undefined" && is_32) {
        voltage = voltage / 0.849;
    }

    var levels = [
        2755.5, 2739, 2730.75, 2722.5, 2712.5, 2706, 2697.75, 2689.5, 2685.375, 2681.25, 2677.125, 2673, 2664.75, 2656.5, 2648.25, 2640, 2615.25, 2582.25, 2433.75, 2062.5
    ];

    var value = 0;
    for (var x in levels) {
        if (voltage >= levels[x]) {
            return (20 - x) * 5;
        }
    }
    return 0;
}

function createDevicePointSeverities(rows) {
    for (var row of rows) {
        var severity_state = 0;

        if (!row.active) {
            severity_state += 100;
        }

        if (row.connectivity == 'offline') {
            severity_state -= 5;
        }
        else {
            severity_state += 10;
        }

        if (row.battery > 60) {
            severity_state += 4;
        }
        else if (row.battery >= 35) {
            severity_state += 2;
        }
        else if (row.battery <= 20) {
            severity_state -= 5;
        }

        if (row.rssi <= 70) {
            severity_state += 2;
        }
        else if (row.rssi <= 85) {
            severity_state += 1;
        }

        if (row.humidity <= 55) {
            severity_state += 2;
        }
        else if (row.humidity > 55 && row.humidity <= 80) {
            severity_state += 1;
        }

        if (row.temperature > 60 || row.temperature < -5) {
            severity_state += 0;
        }
        else if (row.temperature > 45 || row.temperature < 5) {
            severity_state += 1;
        }
        else if (row.temperature <= 45 || row.temperature >= 5) {
            severity_state += 2;
        }

        row.severity_state = severity_state;
    }

    return rows;
}

function sortByDeviceData(a, b) {
    return a.severity_state - b.severity_state;
}

export function processDevicesData(devices, show_inactive = false, group_type = false) {
    var voltage_multiplier = 0.4125;

    var processed = devices.map(function (row) {
        var ret = {};
        var current_time = moment().unix();
        // console.log(row)

        ret.name = row.name;
        ret.serial_number = row.serial_number;
        ret.uuid = row.uuid;
        ret.site_id = row.site_id;

        ret.position = [row.position.longitude, row.position.latitude];

        ret.connectivity = 'offline';
        ret.last_updated = 'Never';
        ret.last_heartbeat = 0;

        ret.battery = "";
        ret.temperature = "";
        ret.rssi = "";
        ret.humidity = "";
        ret.firmware_version = "";
        ret.active = row.active;

        ret.multiplier = typeof row.multiplier != 'undefined' ? row.multiplier : 1;

        if ((group_type && group_type == 'camera') || row.voltage_multiplier == 12.2) {
            voltage_multiplier = 0.825;
        }

        if (typeof row.bks != 'undefined' && row.bks != null) {

            if (['1003', '1004', '1005', '1006', '1007', 'Mercury Carpark (1266)'].indexOf(row.name) > -1) {
                if (current_time - (2 * 60 * 60) <= row.bks.last_heartbeat) {
                    ret.connectivity = 'online';
                }
            }
            else {
                if (current_time - (24.5 * 60 * 60) <= row.bks.last_heartbeat) {
                    ret.connectivity = 'online';
                }
            }

            ret.last_heartbeat = row.bks.last_heartbeat;
            ret.last_updated = moment(row.bks.last_heartbeat * 1000).format('hh:mm A, DD/MM/YY');

            if (typeof row.bks.latest_logs != 'undefined') {

                if (typeof row.bks.latest_logs.status != 'undefined') {
                    ret.battery = calculateBattery(row.bks.latest_logs.status.battery_reading, null, voltage_multiplier) || 0;
                    ret.temperature = row.bks.latest_logs.status.internal_temp || 0;
                    ret.humidity = row.bks.latest_logs.status.internal_humidity || 0;
                }

                if (typeof row.bks.latest_logs.GSMStatus != 'undefined') {
                    ret.rssi = row.bks.latest_logs.GSMStatus.rssi || 0;
                }

                if (typeof row.bks.latest_logs.boot != 'undefined') {
                    ret.firmware_version = row.bks.latest_logs.boot.firmware_version || 0;
                }
            }
        }

        return ret;
    });

    if (!show_inactive) {
        processed = processed.filter(row => { return row.active });
    }

    return createDevicePointSeverities(processed).sort(sortByDeviceData);
}

export function processDeviceData(device, group_type = false) {
    var ret = {};
    var current_time = moment().unix();
    var voltage_multiplier = 0.4125;
    // console.log(row)

    ret.name = device.name;
    ret.serial_number = device.serial_number;
    ret.uuid = device.uuid;
    ret.site_id = device.site_id;

    ret.position = [device.position.longitude, device.position.latitude];

    ret.connectivity = 'offline';
    ret.last_updated = 'Never';
    ret.last_heartbeat = 0;

    ret.battery = "";
    ret.temperature = "";
    ret.rssi = "";
    ret.humidity = "";
    ret.firmware_version = "";
    ret.active = device.active;

    ret.multiplier = typeof device.multiplier != 'undefined' ? device.multiplier : 1;

    if ((group_type && group_type == 'camera') || device.voltage_multiplier == 12.2 ) {
        voltage_multiplier = 0.825;
    }

    if (typeof device.bks != 'undefined') {

        if (['1003', '1004', '1005', '1006', '1007', 'Mercury Carpark (1266)'].indexOf(device.name) > -1) {
            if (current_time - (2 * 60 * 60) <= device.bks.last_heartbeat) {
                ret.connectivity = 'online';
            }
        }
        else {
            if (current_time - (24.5 * 60 * 60) <= device.bks.last_heartbeat) {
                ret.connectivity = 'online';
            }
        }

        ret.last_heartbeat = device.bks.last_heartbeat;
        ret.last_updated = moment(device.bks.last_heartbeat * 1000).format('hh:mm A, DD/MM/YY');

        if (typeof device.bks.latest_logs != 'undefined') {

            if (typeof device.bks.latest_logs.status != 'undefined') {
                ret.battery = calculateBattery(device.bks.latest_logs.status.battery_reading, null, voltage_multiplier) || 0;
                ret.temperature = device.bks.latest_logs.status.internal_temp || 0;
                ret.humidity = device.bks.latest_logs.status.internal_humidity || 0;
            }

            if (typeof device.bks.latest_logs.GSMStatus != 'undefined') {
                ret.rssi = device.bks.latest_logs.GSMStatus.rssi || 0;
            }

            if (typeof device.bks.latest_logs.boot != 'undefined') {
                ret.firmware_version = device.bks.latest_logs.boot.firmware_version || 0;
            }
        }
    }

    return ret;
}